import { render, staticRenderFns } from "./bannerList.vue?vue&type=template&id=061a594f&"
import script from "./bannerList.vue?vue&type=script&lang=js&"
export * from "./bannerList.vue?vue&type=script&lang=js&"
import style0 from "./bannerList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "bannerList.vue"
export default component.exports